import { Button, Menu, MenuItem, Popover, Intent } from "@snpjs/core";
import { Download, FileCsv, MicrosoftExcelLogo } from "@snpjs/icons";
import { useEffect, useState } from "react";

import { AdminViewApi } from "../../api/AdminViewApi";
import { ILicenseLogEntry } from "../../shared/model/ILicenseLogEntry";
import { Table2 } from "../../components/table2/Table2";
import { texts } from "../../i18n/texts";
import { useRequest } from "../../hooks/useRequest";
import useTranslation from "../../hooks/useTranslation";
import { exportTableData } from "./utils/exportTableData";
import styles from "./AdminViewSection.module.scss";

export const CustomerTableSection: React.FC = () => {
  const { t } = useTranslation();
  const request = useRequest();
  const [customerListData, setCustomerListData] = useState<ILicenseLogEntry[]>([]);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [visibleCount, setVisibleCount] = useState<number>(0);

  const fetchCustomerList = async () => {
    setIsLoading(true);
    await request.send(async () => {
      const data = await AdminViewApi.getCustomerList();
      setCustomerListData(data);
      setHasLoaded(true);
    });
    setIsLoading(false);
  };

  const exportData = (format: "csv" | "excel", rows: ILicenseLogEntry[] = customerListData) => {
    exportTableData(rows, format, "customer_table", "CustomerTable");
  };

  const exportMenu = (table?: any) => (
    <Menu>
      <MenuItem
        icon={<FileCsv />}
        text="CSV"
        onClick={() => exportData("csv", table ? table.getFilteredRowModel().rows.map((row: any) => row.original as ILicenseLogEntry) : customerListData)}
      />
      <MenuItem
        icon={<MicrosoftExcelLogo />}
        text="Excel"
        onClick={() => exportData("excel", table ? table.getFilteredRowModel().rows.map((row: any) => row.original as ILicenseLogEntry) : customerListData)}
      />
    </Menu>
  );

  useEffect(() => {
    void fetchCustomerList();
  }, []);

  return (
    <div className={styles.wrapper}>
      {hasLoaded && (
        <div className={styles.countHeader}>{visibleCount} Records Found</div>
      )}
      {hasLoaded && (
        <div className={styles.tableContainer}>
          <Table2
            data={customerListData}
            isLoading={isLoading}
            noResultsTitle={t(texts.adminView.noCustomerTableData)}
            onVisibleCountChange={(count) => setVisibleCount(count)}
            showUtilityToolbar={false}
            enableGlobalFilter={false}
            leftToolbar={(table) => (
              <Popover content={exportMenu(table)} placement="bottom-start" usePortal={false}>
                <Button
                  intent={Intent.PRIMARY}
                  icon={<Download />}
                  rightIcon="caret-down"
                  text="Export"
                  fill
                  alignText="left"
                />
              </Popover>
            )}
          />
        </div>
      )}
    </div>
  );
};
